import { usePaginatedQuery } from 'hooks/usePaginatedQuery'
import { z } from 'zod'
import { api } from '..'
import { paginationSchema } from '../../utils/paginationSchema'

export const deviceModelListItemSchema = z.object({
  id: z.string(),
  provider: z.string().nullable(),
  name: z.string(),
  organizationId: z.string().nullable(),
  photoId: z.string().nullable(),
  photo: z.object({ id: z.string(), url: z.string() }).nullable(),
})
export const deviceModelListSchema = paginationSchema(deviceModelListItemSchema)

export type TModel = z.infer<typeof deviceModelListItemSchema>

export type TModelList = z.infer<typeof deviceModelListSchema>

export const getModelsList = (params?: Record<string, string>) =>
  api
    .get('/v1/device-models', { params })
    .then(({ data }) => deviceModelListSchema.parse(data))

export const modelsListQuery = (params?: Record<string, string>) => ({
  queryFn: () => getModelsList(params),
  queryKey: ['device-models', params],
})

export const useGetModelsList = () => usePaginatedQuery(modelsListQuery)

export const getDeviceModelsSelect = () =>
  api.get<{ items: TModel[] }>('/v1/device-models/list').then(({ data }) => {
    const groupedModels = data.items.reduce<Record<string, TModel[]>>(
      (acc, model) => {
        const groupName = model.provider ?? 'Other'
        acc[groupName] = [...(acc[groupName] ?? []), model]
        return acc
      },
      {},
    )

    return Object.entries(groupedModels).map(([group, items]) => ({
      group,
      items: items.map(({ id, name }) => ({
        value: id,
        label: name,
      })),
    }))
  })

export const deviceModelsSelectQuery = {
  queryKey: ['device-models', 'select'],
  queryFn: getDeviceModelsSelect,
}
